var _pos;
$(window).on('load resize', function () {
	_pos = $('.p-lp2__aboutus').offset().top + $('.p-lp2__aboutus').outerHeight();
});
$(window).scroll(function () {
	if ($(window).scrollTop() + $(window).height() > _pos) {
		$('.js-sticky').addClass('is-show')
	} else {
		$('.js-sticky').removeClass('is-show')
		$('.js-sticky').removeClass('is-hidden')
	}
});

$('.js-stickyClose').click(function(){
	$('.js-sticky').addClass('is-hidden')
})
